import React from "react"
import PropTypes from "prop-types"
import { withRouter } from "react-router-dom"
import { compose } from "recompose"

import Loading from "../../components/atoms/Loading"
import AuthUserContext from "./context"
import { withFirebase } from "../../utils/Firebase"
import * as ROUTES from "../../utils/routes"

const withAuthorization = (condition) => (Component) => {
  class WithAuthorization extends React.Component {
    componentDidMount() {
      const { firebase, history } = this.props
      this.listener = firebase.onAuthUserListener(
        (authUser) => {
          if (!condition(authUser)) {
            localStorage.removeItem("authUserChef")
            history.push(ROUTES.LOGIN)
          }
        },
        () => history.push(ROUTES.LOGIN)
      )
    }

    componentWillUnmount() {
      this.listener()
    }

    render() {
      return (
        <AuthUserContext.Consumer>
          {(authUser) =>
            condition(authUser) ? <Component {...this.props} /> : <Loading />
          }
        </AuthUserContext.Consumer>
      )
    }
  }

  WithAuthorization.propTypes = {
    firebase: PropTypes.shape().isRequired,
    history: PropTypes.shape().isRequired,
  }

  return compose(withRouter, withFirebase)(WithAuthorization)
}

export default withAuthorization
